import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import { trackingStore } from '@stores/Tracking';
import css from '../PlanFeatures/PlanFeatures.module.scss';
import { TierEntry } from '../TierEntry/TierEntry';

const ENTERPRISE_FEATURES = [
  'Custom workflows & automations',
  'Custom skills & cookbooks',
  'Dedicated account manager',
  'Full API access',
  'Higher limits & priority support',
];

/** The contact-sales card that closes the plan row on the Pricing page and the paywall. */
export const EnterpriseTierEntry = ({ source }: { source: 'pricing-page' | 'paywall' }) => (
  <TierEntry
    product={{
      name: 'Enterprise',
      tagline: 'For teams with large libraries and bespoke workflows',
      price: "Let's talk",
    }}
    productType="custom"
    ctaProps={{
      text: 'Get in touch',
      variant: 'secondary',
      onClick: () => {
        trackingStore.contactSalesClicked({ source });
        window.location.href = 'mailto:sales@starzero.ai';
      },
    }}
    tier="enterprise"
    smallPrice
  >
    <div className={css.subscriptionFeatures}>
      {ENTERPRISE_FEATURES.map((feature) => (
        <div key={feature} className={css.featureLine}>
          <CheckRoundedIcon className={css.featureIcon} />
          <span>{feature}</span>
        </div>
      ))}
    </div>
  </TierEntry>
);
